import React, {Component} from 'react'
import {Control, Errors} from 'react-redux-form'
import ArrowButton from '../../../common/button-arrow'
import {Row, Col, FormGroup, ControlLabel, FormControl} from 'react-bootstrap'
import {validators} from "../../../../utils/validators"

class RequiredAutoloadDate extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {

    return (

      <div>

        <Row>
          <Col lg={12} className="autoload-date-col">
            <FormGroup controlId="requiredAutoloadDate" validationState={this.state['autoload_date']}>
              <ControlLabel>Autoredemption dates dd/mm*</ControlLabel>
              <Control
                model='.autoload_date'
                validators={{required: validators.required(this.updateErrors, 'autoload_date')}}
                placeholder="dd/mm"
                pattern="\d\d/\d\d"
                component={FormControl}/>

              <Errors
                show={{
                  touched: true,
                  focus: false
                }}
                className="errors"
                model='.autoload_date'
                messages={{
                  required: 'This field is required',
                  patternMismatch: 'Value does not match the required pattern'
                }}/>
            </FormGroup>

            <ArrowButton className="invisible-button"
                         submit={false}
                         arrow={false}>Delete</ArrowButton>
          </Col>
        </Row>
      </div>
    )
  }
}

export default RequiredAutoloadDate


// WEBPACK FOOTER //
// ./src/components/admin/ppc/settings/required-autoload-date.jsx